import { render, staticRenderFns } from "./MatterAppealInfoList.vue?vue&type=template&id=ef90d9c0&"
import script from "./MatterAppealInfoList.vue?vue&type=script&lang=js&"
export * from "./MatterAppealInfoList.vue?vue&type=script&lang=js&"
import style0 from "./MatterAppealInfoList.vue?vue&type=style&index=0&id=ef90d9c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports